import OABtnDel from './src/btnDel.vue';

/* istanbul ignore next */
OABtnDel.install = function(Vue) {
  Vue.component('oa-btn-del', OABtnDel);
};

export default OABtnDel;



// WEBPACK FOOTER //
// ./src/components/oa/view/official/cmps/btnDel/index.js